module.exports = __webpack_public_path__ + "static/media/grid.2c0f22a1.svg";